export default function convertBooleanString(value) {
  if (value != null && typeof value === 'string' && ['true', 'false'].includes(value)) {
    return value === 'true';
  }
  return value;
}
